import {type SandboxSession} from '@packages/domains/code-libraries/data-types';
import {once, weakMemo} from '@packages/utilities/memo';

export const SANDBOX_REQUIRED_TOOL_IDS = new Set([
  'read-remote-file',
  'write-remote-file',
  'write-remote-files',
  'test-run-function',
  'delete-remote-files',
  'edit-remote-file',
  'edit-remote-file-exact',
]);

const getSandboxClient = once(async () => {
  const {SandboxInstance} = await import('@blaxel/core');
  return SandboxInstance;
});

export const getSandboxClientFromSession = weakMemo(
  async (session: SandboxSession) => {
    const SandboxInstance = await getSandboxClient();
    return SandboxInstance.fromSession(session);
  }
);

export const isSessionExpired = (session: SandboxSession): boolean => {
  const expiresAt = new Date(session.expiresAt);
  const now = new Date();
  // Add a 30 second buffer before actual expiration
  return now.getTime() >= expiresAt.getTime() - 30000;
};
